import { render, staticRenderFns } from "./editorPopoverButton.vue?vue&type=template&id=185dc088&"
import script from "./editorPopoverButton.vue?vue&type=script&lang=js&"
export * from "./editorPopoverButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports